import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getScheduleId } from "library/get-unique-id-from-tree"
import { convertToKebabCase } from "lib/case-helper"
import { Activity } from "routes/audit/component/activity-button"
import { TAILORING_AUDIT_TYPE } from "./server/tailoring-audit-constants.mjs"
import { TailoredChangedTitleAbove } from "./tailored-changes"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Frag } from "lib/@components/slot/frag"
import { useTailoringReferenceId } from "./hooks/use-tailoring-reference-id"

export function TailoredActivity() {
    const { schedule } = useBoundContext()
    const { referenceId } = useTailoringReferenceId()

    TailoredChangedTitleAbove.usePlug(replaceAllWith(<Frag />))

    const scheduleId = getScheduleId(schedule?.id)
    const fileName = convertToKebabCase(schedule.title || "activity")
    const filter = { "payload.scheduleId": scheduleId }

    return (
        <Activity
            type={TAILORING_AUDIT_TYPE}
            passedId={referenceId}
            fileNamePrefix={fileName}
            filter={filter}
            pageSize={50}
        />
    )
}
